<div class="common-dropdown" #panelDOM>
    <div class="common-dropdown-trigger" (click)="toggleMenu()">
        <ng-container *ngIf="trigger else defaultTrigger">{{ trigger }}</ng-container>
        <ng-template #defaultTrigger><img src="/assets/icons/bento-menu.svg"></ng-template>
    </div>
    <div class="common-dropdown-menu" *ngIf="showMenu" (click)="toggleMenu()">
        <ng-content select="[menu]"></ng-content>
    </div>
</div>